import React from 'react';
import { Pricing } from '../components/Pricing';
import { PaymentMethods } from '../components/PaymentMethods';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function PricingPage() {
  return <main className="pt-24" data-id="element-464">
      <section className="bg-surface py-20 text-center border-b border-gray-100" data-id="element-465">
        <div className="container mx-auto px-4" data-id="element-466">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6" data-id="element-467">
            Transparent Pricing
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-muted max-w-2xl mx-auto" data-id="element-468">
            No hidden fees. No long-term contracts. Just results-driven packages
            designed to scale with your business.
          </motion.p>
        </div>
      </section>

      <Pricing data-id="element-469" />
      <PaymentMethods data-id="element-470" />
      <Testimonials data-id="element-471" />
      <CTASection data-id="element-472" />
    </main>;
}